import { render, staticRenderFns } from "./ClassAdministrativeTabs.vue?vue&type=template&id=4b484944"
import script from "./ClassAdministrativeTabs.vue?vue&type=script&lang=js"
export * from "./ClassAdministrativeTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports